// extracted by mini-css-extract-plugin
module.exports = {"labelComponent":"_3OK8HCPh-bFLCxCvnyeg-k"};